import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import eventService from "./eventService";

// Async actions
export const getEvents = createAsyncThunk("event/get-events", async (_, thunkAPI) => {
  try {
    return await eventService.getEvents();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const createEvent = createAsyncThunk("event/create-event", async (data, thunkAPI) => {
  try {
    return await eventService.createEvent(data);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getAnEvent = createAsyncThunk("event/get-event", async (id, thunkAPI) => {
  try {
    return await eventService.getEvent(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const updateAnEvent = createAsyncThunk("event/update-event", async (data, thunkAPI) => {
  try {
    return await eventService.updateEvent(data);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteAnEvent = createAsyncThunk("event/delete-event", async (id, thunkAPI) => {
  try {
    return await eventService.deleteEvent(id);
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const resetState = createAction("Reset_all");

const initialState = {
  events: [],
  isLoading: false,
  isError: false,
  isSuccess: false,
  message: "",
};

export const eventSlice = createSlice({
  name: "events",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEvents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getEvents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.events = action.payload;
      })
      .addCase(getEvents.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(createEvent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdEvent = action.payload;
      })
      .addCase(createEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(getAnEvent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAnEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.eventData = action.payload;
      })
      .addCase(getAnEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(updateAnEvent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAnEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedEvent = action.payload;
      })
      .addCase(updateAnEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(deleteAnEvent.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAnEvent.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEvent = action.payload;
      })
      .addCase(deleteAnEvent.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })

      .addCase(resetState, () => initialState);
  },
});

export default eventSlice.reducer;
